module.exports = __webpack_public_path__ + "e9053d161dff45838cc4d6c167f5694d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Off-Black_Big_RGB.png
// module id = 184
// module chunks = 0